<template>
	<v-app>
		<v-main class="d-flex align-center">
			<v-container class="mx-auto">
				<v-row>
					<v-col cols="12" sm="12" md="6" style="min-width: 100px; max-width: 100%;"
						class="flex-grow-1 flex-shrink-0">


						<v-row class="d-flex justify-content-center justify-content-lg-start mb-4">



							<!-- Logo -->
							<router-link :to="{
								path: '/',
							}" title="TicketShop" tag="a"><v-img max-height="64" max-width="85" src="/images/Logo-black.svg"></v-img>
							</router-link>

						</v-row>

						<v-col cols="12" md="10" class="d-flex mx-auto align-content-space-around flex-column ">

							<v-card-title class="font-weight-bold" tag="h4">
								Iniciar sesión
							</v-card-title>
							<v-card-subtitle style="											font-weight: 500;
											" tag="h6">Bienvenido, por favor ingrese sus
								datos
							</v-card-subtitle>

							<!-- //Formulario  -->
							<v-col cols="12" class="mt-n4">
								<v-form @submit.prevent="doLogin" autocomplete="on" class="mb-0 align-content-space-between">
									<!-- Correo Electronico -->
									<v-card-subtitle class="px-0 mx-0">Correo </v-card-subtitle>
									<v-text-field height="56px" solo placeholder="ejemplo@correo.com" required v-model="user.email
										">
									</v-text-field>
									<!-- Contraseña -->
									<v-card-subtitle class="px-0 mx-0">Contraseña </v-card-subtitle>
									<v-text-field
          label="Contraseña"  v-model="user.password" type="password"  solo required ></v-text-field>

									<v-row class="d-flex align-center justify-content-between">
										<v-checkbox small class="text-subtitle-1" v-model="checkbox"
											:label="`Recuerdame`"></v-checkbox>
										<a @click.prevent="goPasswordReset
										" href="#" class="primary--text text-subtitle-1">¿Olvidaste tu contraseña?</a>
									</v-row>



									<v-btn class="text-button" color="primary" height="44px" block rounded type="submit">Iniciar
										Sesión
									</v-btn>
									<router-link :to="{ path: '/' }" title="TicketShop" tag="a">
										<v-btn outlined class="text-button mt-4" color="primary" height="44px" block rounded
											type="submit">Volver
										</v-btn>
									</router-link>
								</v-form>
							</v-col>
							<v-row max-width="360">
								<v-col cols="12" class="d-flex align-center flex-column">
									<v-text class="text-subtitle-1">¿No tienes cuenta de
										usuario?
									</v-text>
									<router-link :to="{ path: '/registro' }">
										<v-text class="primary--text text-title font-weight-bold">Registrarme
											Ahora</v-text>
									</router-link>
								</v-col>
							</v-row>

						</v-col>

						<v-spacer></v-spacer>
						<v-row>
							<v-col class="py-4 py-md-0 ">
								<v-text tag="h6" width="100%" class="d-flex align-self-sm-end ml-5  text-body-2">
									© TicketShop
									{{ new Date().getFullYear() }} Colombia.
								</v-text>
							</v-col>
						</v-row>


					</v-col>
					<v-col v-if="$vuetify.breakpoint.mdAndUp" md="6">
						<v-img fill-height cover style="height: 100%;" src="/images/login/LOGIN.webp">
						</v-img>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>
<script>
export default {
	created() { },
	data() {
		return {
			user: {
				email: null,
				password: null,
				showPassword: false,
				passwordRules: [
        v => !!v || 'La contraseña es requerida',
        v => (v && v.length >= 8) || 'La contraseña debe tener al menos 8 caracteres',
      ],
			},
		};
	},
	methods: {
		doLogin() {
			this.$store.dispatch("doLogin", this.user);
		},
		showFormRegister() {
			this.$store.state.modalLogin = false;
			this.$store.state.modalRegister = true;
		},
		goPasswordReset() {
			this.$store.state.modalLogin = false;
			this.$router.push("/passwordReset");
		},
		hideModalLogin() {
			this.$store.commit("showModalLogin", false);
		},
	},
	computed: {
		modalLogin() {
			return this.$store.getters["modalLogin"];
		},
	},
};
</script>
